const authMiddleware = () => {
    const isAuthenticated = localStorage.getItem('authToken');
    
    if (isAuthenticated) {
        return true;
    } else {
        window.location.href = '/login'; 
        return false;
    }
};

export default authMiddleware;